/*
 * action types
 */
import { fetchUser, setUser } from "./actions/Users";
import ReactGA from "react-ga";
import Configuration, { translations } from "./config";

export const SET_CREATED_TREE_KEY = "SET_CREATED_TREE_KEY";

export const SET_SHOW = "SET_SHOW";
export const SET_TITLE = "SET_TITLE";

export const SET_IS_FETCHING = "SET_IS_FETCHING";
export const SET_ROUTE = "SET_ROUTE";
export const SET_HISTORY_ROUTE = "SET_HISTORY_ROUTE";

export const MESSAGE = "MESSAGE";
export const REMOVE_MESSAGE = "REMOVE_MESSAGE";
export const REFRESH_MESSAGES = "REFRESH_MESSAGES";

/*
 * action creators
 */

export function setCreatedTreeKey( value )
{
	return {
		type: SET_CREATED_TREE_KEY,
		value
	};
}

export function setCurrentShow( value )
{
	return {
		type: SET_SHOW,
		value
	};
}

export function setTitleAndScrollToTop( a_value )
{
	let value = a_value;
	
	if ( typeof value === "object" )
	{
		value = "";
		Object.keys( a_value.props.children ).forEach( a_key =>
			{
				if ( typeof a_value.props.children[a_key] !== "object" )
				{
					value = `${value}${a_value.props.children[a_key]}`;
				}
			}
		);
	}
	
	document.title = `${translations.de_DE.words.appName} | ${value}`;
	
	window.scrollTo( 0, 0 );
	
	return {
		type: SET_TITLE,
		value: a_value
	};
}

export function setIsFetching( value )
{
	return {
		type: SET_IS_FETCHING,
		value
	};
}

export function setRoute( route )
{
	return {
		type: SET_ROUTE,
		route
	};
}

export function setHistoryRoute( route )
{
	return {
		type: SET_HISTORY_ROUTE,
		route
	};
}

// BEGIN Message Functions
export function refreshMessages()
{
	return { type: REFRESH_MESSAGES };
}

export function showMessage( message, uniqueByMessage )
{
	return { type: MESSAGE, message, uniqueByMessage };
}

export function removeMessage( id )
{
	return { type: REMOVE_MESSAGE, id };
}

export function message( message, type = null, timeout = false, uniqueByMessage = true )
{
	return function( dispatch )
	{
		const defaultTimeout = 5000;
		timeout = !type ? defaultTimeout : timeout;
		
		message = {
			id: "message_" + ( Date.now() + Math.random() ),
			message: message,
			timeout: timeout ? ( +new Date() ) + timeout : false
		};
		
		switch ( type )
		{
			case "error":
				message.type = "error";
				break;
			
			case "warning":
				message.type = "warning";
				break;
			
			default:
				message.type = "info";
		}
		
		// display message
		dispatch( showMessage( message, uniqueByMessage ) );
		
		// automatic removal of the message
		if ( timeout )
		{
			window.setTimeout( () => dispatch( refreshMessages() ), timeout );
		}
	};
	
} // function message()

export function setUserGuest( a_redirect = true )
{
	return function( dispatch )
	{
		// setze Gastnutzer Erkennung
		dispatch( setUser( {
			permissions: [ "guest_user_permissions" ],
			roles: [ "Guest" ],
			isActive: true
		} ) );
		localStorage.removeItem( "jwt" );
		
		if ( a_redirect )
		{
			dispatch( setRoute( "/" ) );
		}
	};
	
} // function setUserGuest()

/**
 * Nutzt die Api um die Konfigurationsdaten im Store zu speichern
 */
export function getConfigurations()
{
	return function( dispatch, getState )
	{
		dispatch( setIsFetching( true ) );
		
		return fetch(
			`${Configuration.apiUrl}/configurations`,
			{
				credentials: "include",
				method: "GET"
			}
		)
			.then(
				response =>
				{
					if ( response.ok )
					{
						response.json()
							.then( json =>
								{
									// Google Analytics code and verification code merken
									localStorage.setItem( "gac", json.googleAnalyticsKey );
									localStorage.setItem( "gvc", json.googleVerficationCode );
									localStorage.setItem( "environment", json.environment );
									ReactGA.initialize( json.googleAnalyticsKey );
								}
							);
					}
					else
					{
						response.json()
							.then( json =>
								{
									// Der Nutzer erfährt warum die Anfrage fehlgeschlagen ist.
									dispatch( message( json.error, "error" ) );
								}
							);
					}
					
					dispatch( fetchUser() );
					dispatch( setIsFetching( false ) );
				}
			)
			.catch(
				error =>
				{
					dispatch( message( "Der Dienst steht derzeit nicht zur Verfügung. Bitte versuchen Sie es später erneut.", "error" ) );
					dispatch( setIsFetching( false ) );
				}
			);
	};
	
} // function getConfigurations()